import authRules from '../authRules.js';

const addAssignmentEditActivityType = (user) => {
  const { activityType } = user.securityLevels;
  if (activityType >= authRules.addAssignmentEditActivityType.activityType) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentEditActivityType;
